import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { Loader } from "@/components";
import useNotes from "./useNotes";
import { approvedTabs, fakeTabs, tabs } from "./consts";
import { images } from "@/assets";
import moment from "moment";
import { cn } from "@/lib/utils";

const Notes = () => {
  const {
    isLoadingNote,
    activeTab,
    onChangeTab,
    noteListByRole,
    isPlanApproved
   } = useNotes();

  return (
    <div className="pt-[20px] pb-10 px-5 no-scrollbar">
      <Tabs value={activeTab} defaultValue="task-planning">
        <TabsList className="bg-transparent w-full">
          {[...tabs, ...isPlanApproved ? approvedTabs : fakeTabs]?.map((data: any, index: any) => (
            <TabsTrigger
              key={data?.value}
              value={data?.value}
              onClick={() => onChangeTab(data.value)}
              className="font-[12px]"
              disabled={!isPlanApproved && index != 0}
            >
              {data?.title}
            </TabsTrigger>
          ))}
        </TabsList>
        {/* <div className="h-[0.5px] w-[100%] bg-gray-200 "/> */}
        <div className={cn("max-h-[calc(100vh-300px)] overflow-y-scroll")}>
          <TabsContent value={activeTab}>
            {isLoadingNote ? <Loader /> : noteListByRole?.length == 0 ? 
              <div className="flex items-center justify-center">
                <img src={images.no_data} className="h-[100px]" />
              </div> : 
              <ul className="flex flex-col gap-3">
                {noteListByRole?.map((data: any, index: number) => 
                  <li className="text-[14px]">
                    <span className="text-yellow-700">{index+1}. Remark By: {data?.createdByName || ""} on {moment(data?.createdAt).format('MM-DD-YYYY')} - </span> {data?.note}
                  </li>
                )}
              </ul>
            }
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default Notes;
